// The platform adapter: everything the shared data layer needs from the device, supplied once at
// startup by the app (packages/mobile/src/platform.js, packages/web/src/platform.js) with
// setPlatform(). Nothing in @battleops/client may import react-native, expo-* or the DOM directly.
//
// {
//   os: 'android' | 'ios' | 'web',
//   appVersion: string | null,          // shown to the server on opsRegisterDevice
//   runtimeVersion: string | null,      // the phone's native runtime (null on the desktop web app)
//   pushToken?: () => Promise<string | null>,  // the phone's FCM token (approval push); absent on web
//   apiBaseUrl: string,
//   kv: { getItem, setItem, removeItem },                       // async, string values
//   secure?: { get(k), set(k, v), remove(k) } | null,           // the phone's keystore (locked-notes key); none on web
//   driver: (name) => Driver,                                   // @battleops/localstore driver for the DB `name`
//   sdk: { initializeApp, initAuth(app), getFunctions, httpsCallable,
//          signInWithEmailAndPassword, signOut, sendPasswordResetEmail, onAuthStateChanged },
//   net: { fetch(): Promise<boolean>, subscribe(fn(up)): unsubscribe },
//   appState: { current(): 'active' | 'background' | string, subscribe(fn(state)): unsubscribe },
//   files: { putFile(url, localUri, contentType), downloadToCache(url, name) },
//   media: { keepTaskMedia(taskId, task), uploadedForNote(noteId) } | null,   // on-device media queue (optional)
//   background: { armSyncTask(), followOutbox(status) },          // no-ops on web
//   onBeforeReloadLast(fn),                                     // run fn last before an in-app restart
//   tabs: {                                                     // web only: several tabs on one database
//     coordinator(dbName) → TabCoordinator | null,              // @battleops/localstore webTabs
//     electLeader(dbName, onLead) → giveUp,                     // @battleops/localstore electLeader
//     channel(dbName) → { post(msg), subscribe(fn) → unsub, close() },   // sync relay between tabs
//   } | null,
// }
let current = null;

export function setPlatform(p) { current = p; }

export function platform() {
  if (!current) throw new Error('@battleops/client: setPlatform() has not been called');
  return current;
}

export const hasPlatform = () => current !== null;
